import { AxiosInstance } from '../../../utilities/requestClient';
import {
  AggregationData,
  mapMacroAggregationResponse,
} from './types';

/** HG bottle route: GET /aggregation (MACRO resource). */
export const AGGREGATION_PATH = 'aggregation';

export const fetchAggregationData = async (): Promise<AggregationData> => {
  const { data } = await AxiosInstance.get(AGGREGATION_PATH);
  return mapMacroAggregationResponse(data);
};
